import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 7BBC57AE-0EBA-4198-8B85-5082A38522DE
 * name folder-open
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-open.svg
 * tags
 * - Files / Folders 
 */
export const FolderOpenIcon = createSvgIcon(<><path d="M19,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10L12,6H19A2,2 0 0,1 21,8H21L4,8V18L6.14,10H23.21L20.93,18.5C20.7,19.37 19.92,20 19,20Z" /></>, 'FolderOpenIcon');
export default FolderOpenIcon